import Pull from './Pull';
import LocaleReceiver from '../locale-receiver';
export default LocaleReceiver('Pull')(Pull);